import { Reveal } from './reveal.js'
import { SplitTextInstance } from './split-text.js'

export class InViews {
  constructor () {
    this.inViews = [...document.querySelectorAll('.js-in-view')]

    this.observer = new window.IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          const type = entry.target.getAttribute('data-name')
          new Reveal(entry.target, type).reveal()
          this.observer.unobserve(entry.target)
        }
      })
    })

    this.inViews.forEach(inView => {
      const split = inView.hasAttribute('data-split') ? inView.getAttribute('data-split') : false

      if (split) {
        new SplitTextInstance(inView, split)
      }

      this.observer.observe(inView)
    })
  }
}
